module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_24-46b8c3e98797e2252c11580e03bc1b65.jpg";